import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Tabs(theme: Theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        flexContainer: {
          display: 'flex',
          gap: theme.spacing(3),
        },
        indicator: {
          height: 2,
        },
        scrollButtons: {
          '&.Mui-disabled': { display: 'none' },
        },
      },
    },
    MuiTab: {
      defaultProps: {
        disableFocusRipple: true,
        disableRipple: true,
        disableTouchRipple: true,
      },
      styleOverrides: {
        root: {
          padding: 0,
          paddingX: 0.5,
          minWidth: 'auto',
          fontWeight: theme.typography.fontWeightRegular,
          fontSize: 16,
          color: theme.palette.text.primary,
          '&.Mui-selected': {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightBold,
          },
        },
      },
    },
  };
}
